module.exports = __webpack_public_path__ + "static/assets/d10c9ca110b3e54e6aede46625e33594.png";